import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { SwalComponent, SwalPortalTargets } from '@sweetalert2/ngx-sweetalert2';
import { DeleteActionType } from 'common/enums';
import { SweetAlertCustomClass, SweetAlertOptions } from 'sweetalert2';

@Component({
    selector: 'confirm-delete-all-alert',
    templateUrl: './confirm-delete-all-alert.component.html',
    standalone: false
})
export class ConfirmDeleteAllAlertComponent {
  @ViewChild('deleteSwal')
  public readonly deleteSwal!: SwalComponent;

  @Input() options!: SweetAlertOptions;
  @Input() customClass!: SweetAlertCustomClass;
  @Input() showDeleteAllButton: boolean = false;
  @Input() deleteAllButtonText: string = 'Yes, delete all!';

  public constructor(public readonly swalTargets: SwalPortalTargets) { }

  public deleteAllData(event: any): void {
    this.deleteSwal.close({
      isConfirmed: true,
      isDenied: false,
      isDismissed: false,
      value: { delete: DeleteActionType.DeleteAll }
    });
  }

  public deleteData(event: any): void {
    this.deleteSwal.close({
      isConfirmed: true,
      isDenied: false,
      isDismissed: false,
      value: { delete: DeleteActionType.DeleteSingle }
    });
  }

  public cancel(event: any): void {
    this.deleteSwal.close({
      isConfirmed: false,
      isDenied: false,
      isDismissed: true
    });
  }
}
